(() => {
  const bankHolidays = new Set(["2026-01-01","2026-01-02","2026-03-17","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-06-15","2026-07-13","2026-08-03","2026-08-31","2026-11-30","2026-12-25","2026-12-28","2027-01-01","2027-01-04","2027-03-17","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-07-12","2027-08-02","2027-08-30","2027-11-30","2027-12-27","2027-12-28","2028-01-03","2028-01-04","2028-03-17","2028-04-14","2028-04-17","2028-05-01","2028-05-29","2028-07-12","2028-08-07","2028-08-28","2028-11-30","2028-12-25","2028-12-26"]);
  const dayKey = (date) => date.toISOString().slice(0, 10);
  const marketSettings = { GB: { transitDays: 9, locale: 'en-GB' }, US: { transitDays: 8, locale: 'en-US' } };
  const orderDay = (now, country) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    if (country === 'GB') options.timeZone = 'Europe/London';
    const parts = new Intl.DateTimeFormat('en-GB', options).formatToParts(now);
    const part = (type) => Number(parts.find((entry) => entry.type === type).value);
    return new Date(Date.UTC(part('year'), part('month') - 1, part('day'), 12));
  };
  const addProcessingDays = (date, count, country) => {
    const result = new Date(date);
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (![0, 6].includes(result.getUTCDay()) && (country !== 'GB' || !bankHolidays.has(dayKey(result)))) count -= 1;
    }
    return result;
  };
  class KenzeDeliveryEstimate extends HTMLElement {
    static get observedAttributes() { return ['data-available']; }
    static estimate(now = new Date(), country = 'GB') {
      const market = marketSettings[country];
      if (!market) return [];
      const today = orderDay(now, country);
      const dates = [1, 3].map((days) => {
        const arrival = addProcessingDays(today, days, country);
        arrival.setUTCDate(arrival.getUTCDate() + market.transitDays);
        return arrival;
      });
      return dates;
    }
    connectedCallback() {
      this.refresh = () => this.renderEstimate();
      this.renderEstimate();
      this.timer = window.setInterval(this.refresh, 60000);
      window.addEventListener('pageshow', this.refresh);
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      window.removeEventListener('pageshow', this.refresh);
      document.removeEventListener('visibilitychange', this.refresh);
    }
    attributeChangedCallback() {
      if (this.isConnected) this.renderEstimate();
    }
    renderEstimate() {
      const output = this.querySelector('[data-delivery-range]');
      if (!output) return;
      const market = marketSettings[this.dataset.country];
      const eligible = Boolean(market) && this.dataset.available === 'true';
      this.hidden = !eligible;
      if (!eligible) return;
      const formatter = new Intl.DateTimeFormat(market.locale, { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
      output.textContent = KenzeDeliveryEstimate.estimate(new Date(), this.dataset.country).map((date) => formatter.format(date)).join(' – ');
    }
  }
  if (!customElements.get('kenze-delivery-estimate')) customElements.define('kenze-delivery-estimate', KenzeDeliveryEstimate);
})();
